import React from 'react';
import {
  withStyles,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';

class MainOrganizationForm extends React.PureComponent {

  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleCloseForm}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div className={classes.textHeader}>{t('wizard_main_organization_detail')}</div>
            <div id='closeIcon' className='closeIcon' onClick={this.props.handleCloseForm}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_main_organization_name')}*
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={this.props.data.name}
                onChange={(e) => this.props.handleChange(e)}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
              <FormHelperText error hidden={!this.props.errorField.name.flag} id='component-error-text'>
                {this.props.errorField.name.msg}
                {/* {t(`${this.state.errorField.name.msg}`)} */}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_main_organization_contact')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='contactPerson'
                name='contactPerson'
                fullWidth
                value={this.props.data.contactPerson}
                onChange={(e) => this.props.handleChange(e)}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_main_organization_phone')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='phoneNumber'
                name='phoneNumber'
                fullWidth
                value={this.props.data.phoneNumber}
                onChange={(e) => this.props.handleChange(e)}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
                inputProps={{ maxLength: 10 }}
              />
              <FormHelperText error hidden={!this.props.errorField.phoneNumber.flag} id='component-error-text'>
                {this.props.errorField.phoneNumber.msg}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_main_organization_email')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='email'
                name='email'
                fullWidth
                value={this.props.data.email}
                onChange={(e) => this.props.handleChange(e)}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[ก-๙]/, '');
                }}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
              <FormHelperText error hidden={!this.props.errorField.email.flag} id='component-error-text'>
                {this.props.errorField.email.msg}
              </FormHelperText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            style={{
              margin: '20px',
              justifyContent: 'right',
            }}
          >
            <Button
              id='save'
              variant='contained'
              color='primary'
              className={classes.btnPrimary}
              onClick={this.props.handleSubmitForm}
            >
              {t('save')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 200,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
});

// export const page = inject("wizard")(observer(MainOrganizationForm));
export const translation = withTranslation()(MainOrganizationForm);
export default withStyles(styles, { withTheme: true })(translation);
